module.exports = __webpack_public_path__ + "img/product_27.2c4b8ef.webp";